<template>
  <div :class="'app-content cat-layout-task service-code ' + service.code">
    <cat-skip-link
      :link-text="resolveTxt('skin.skip.to.content', 'Skip to main content')"
      link="#maincontent"
    ></cat-skip-link>

    <!-- <cat-page-help v-on:help-show="toggleHelp" /> -->
    <!--<cat-language-selector />-->

    <cat-background />

    <cat-header :catalyst-api="catalyst">
      <template #header-controls>
        <cat-account
          :user="user"
          :organisation-identifier="organisationIdentifier"
        ></cat-account>
      </template>
    </cat-header>

    <!-- <div class="nav-bar filled pattern"> -->
    <div class="nav-bar filled invert-text pattern">
      <div class="grid-container">
        <div class="grid-x">
          <div v-if="!hideNavigation" class="small-12 grid-margin-x">
            <nav>
              <ul>
                {{
                  service.title
                }}
                <!-- <li><a href="dashboard.html" title="View dashboard">Dashboard</a></li> -->
                <!--<li><a class="open-finder" title="Find a page or service">Online services</a></li>-->
              </ul>
            </nav>
          </div>

          <div v-if="hideNavigation" class="header-group">
            <h1 data-label-type="heading">{{ service.name }}</h1>
          </div>
        </div>
      </div>
    </div>

    <!--<cat-language-selector/>-->

    <!--<cat-account-->
    <!--:user="user"-->
    <!--:account-context="accountContext"-->
    <!--:organisation-identifier="organisationIdentifier"-->
    <!--&gt;</cat-account>-->

    <cat-background />

    <div
      id="maincontent"
      ref="menuTarget"
      tabindex="-1"
      role="main"
      :aria-label="resolveTxt('skin.main.content', 'Main Content')"
      :class="additionalClasses"
    >
      <div class="grid-container">
        <div>
          <div class="grid-x grid-margin-x">
            <div class="small-12 cell">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cat-page-help
      :url="helpUrl"
      :open="helpDrawer"
      :source-id="helpSourceId"
      :title="helpSourceTitle"
      :section-help="sectionHelp"
      show-tooltip
      @ui-close="closeHelp(viewtree.helpUrl)"
    />
    <!-- Help URL '{{this.viewtree.helpUrl}}' -->
    <cat-footer :content="footerContent" class="footerFrame" />
    <cat-throbber />
  </div>
</template>

<script lang="ts">
import { defineComponent, inject } from "vue";
import jQuery from "jquery";
import CatSkipLink from "@/components/catSkipLink/catSkipLink";
import CatAccount from "../catAccount/catAccount";
import CatFooter from "./footer";
// import CatNav from "./left-nav";
import CatThrobber from "./throbber";
// import CatHelp from "./help";
import CatBackground from "./background-layer";
import CatPageHelp from "./catPageHelp";
// import CatCmsContent from "./catCmsContent";
// import CatLanguageSelector from "./language-selector";
import CatHeader from "./header";
import PageHelpMixin from "@/components/catPageTemplate/pageHelpMixin";
import { defaultResolveTxt } from "@/components/field-element";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);
    const displayParams = inject("displayParams", false);

    return {
      resolveTxt,
      displayParams
    };
  },
  name: "CatTaskLayout",
  components: {
    CatSkipLink,
    CatAccount,
    CatFooter,
    // CatNav,
    CatPageHelp,
    CatBackground,
    CatThrobber,
    // CatLanguageSelector,
    CatHeader
  },
  mixins: [PageHelpMixin],
  props: {
    viewtree: {
      type: Object
    },
    // Pass in the Catalyst API so we can replace it in unit tests
    catalystApi: {
      type: Object,
      default: window["Catalyst"]
    }
  },
  data: function () {
    return {
      helpUrl: this.viewtree.helpUrl,
      drawer: false,
      user: this.viewtree.usr,
      organisationIdentifier: this.viewtree.organisationIdentifier,
      additionalClasses: [],
      service: this.viewtree.svc,
      catalyst: this.catalystApi || window["Catalyst"],
      footerContent: this.viewtree.footerContent
    };
  },
  computed: {
    hideNavigation: function () {
      // Using display group so a service can pretend to be of a different type if needed.
      return this.service.group == "create" || this.service.group == "change";
    }
  },

  methods: {
    toggleMenu: function (evt) {
      this.drawer = !this.drawer;
    },
    addContentClass: function (classname) {
      if (this.additionalClasses.indexOf(classname) == -1) {
        this.additionalClasses.push(classname);
      }
    },
    handleSubmit: function (evt) {
      if (
        this.viewtree.root &&
        this.viewtree[this.viewtree.root].kv &&
        this.viewtree[this.viewtree.root].kv.submitNodeId
      ) {
        Catalyst.processUpdate({
          type: "buttonClicked",
          nodeId: this.viewtree[this.viewtree.root].kv.submitNodeId,
          start: function () {
            Catalyst.showOverlay("Processing");
          },
          finish: function () {
            Catalyst.hideOverlay();
          },
          commands: [
            {
              type: "view-node-button-click",
              id: this.viewtree[this.viewtree.root].kv.submitNodeId
            }
          ]
        });
      }
    }
  },
  mounted: function () {
    if (
      navigator.userAgent.indexOf("MSIE") !== -1 ||
      navigator.appVersion.indexOf("Trident/") > -1
    ) {
      /* Microsoft Internet Explorer detected in. */
      document.querySelector("body").classList.add("if-ie");
    }
    this.initPageHelp(this.viewtree.helpUrl);
  },
  provide: function () {
    return {
      suppressExternalHelp: this.service.suppressExternalHelp,
      addContentClass: this.addContentClass
    };
  }
});
</script>
